import React, { useState } from 'react';
import BannerRight from '../../components/BannerRight';
import AuthWrapper from '../../components/AuthWrapper';
import Home from './pages/Home';
import ForgotPassword from './pages/ForgotPassword';
import AuthHeader from '../../components/header/AuthHeader';
import Footer from '../../components/Footer';

const LoginHelp = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNextStep = (id) => {
    if (id) {
      setCurrentStep(id);
    } else {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <Home handleNextStep={handleNextStep} />;
      case 1:
        return <ForgotPassword />;
      default:
        return null;
    }
  };
  return (
    <div className="flex h-screen overflow-hidden">
      <div className="w-full lg:w-1/2 relative overflow-y-scroll left-form">
        <AuthHeader />
        <AuthWrapper className="max-w-sm">{renderStep()}</AuthWrapper>
        <Footer />
      </div>
      <BannerRight />
    </div>
  );
};

export default LoginHelp;
